//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { Action } from 'redux';

/**
 * Creates a strongly typed action out of the passed in object.
 * @param action A redux action object, usually an object literal.
 */
export function createAction<T extends string, U extends Action<T>>(action: U) {
    // This function is essentially a no-op, but the generic type parameters ensure that
    // the resulting return type looks like:
    // { type: 'UniqueActionConstant' }
    // instead of:
    // { type: string }
    // Which helps us build a discriminated type union
    // out of the return types of a set of action creators.
  return action;
}
